module.exports = __webpack_public_path__ + "img/box-packaging-sm-tmp@2x.abda263a.png";